import { useState } from "react"
import StepDetails from "./step_details"
import { formatToTimestamp } from "app/components/diy_composer/utils/format_time"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

interface TQADetails {
  name: string
  description: string
  channel: {
    brand_color: string
    monochrome_image_url: string
    name: string | ""
  }
}
interface AppletTrigger {
  trigger: TQADetails
}

interface AppletActions {
  action: TQADetails
}

interface AppletQueries {
  query: TQADetails
}

interface Props {
  details: {
    applet_actions: Array<AppletActions>
    applet_queries: Array<AppletQueries>
    applet_trigger: AppletTrigger
    normalized_applet: {
      actions_delay: number
    }
    filter_code: string
  }
}

const AppletDetails = ({ details }: Props) => {
  const [showDetails, setShowDetails] = useState(false)

  const triggerAdded = !!details.applet_trigger
  const queriesAdded = details.applet_queries.length > 0
  const filterCodeAdded = !!details.filter_code
  const actionsAdded = details.applet_actions.length > 0
  const delayAdded = details.normalized_applet.actions_delay > 0

  const formattedDelay = () => {
    return formatToTimestamp(Number(details.normalized_applet.actions_delay))
  }

  const handleShowDetails = () => {
    logIFTTTNextAction("click", {
      object_type: "more_less_detail",
      location_type: "applet_details",
    })

    setShowDetails(!showDetails)
  }

  return (
    <div className="applet-details">
      {showDetails ? (
        <>
          {triggerAdded && (
            <>
              <StepDetails
                label="If"
                brandColor={`#` + details.applet_trigger.trigger.channel.brand_color}
                image={details.applet_trigger.trigger.channel.monochrome_image_url}
                name={details.applet_trigger.trigger.name}
                serviceName={details.applet_trigger.trigger.channel.name}
                description={details.applet_trigger.trigger.description}
              />
            </>
          )}
          {queriesAdded &&
            details.applet_queries.map(query => (
              <>
                <StepDetails
                  label="With"
                  brandColor={`#` + query.query.channel.brand_color}
                  image={query.query.channel.monochrome_image_url}
                  serviceName={query.query.name}
                  description={query.query.description}
                  name="Query"
                />
              </>
            ))}
          {filterCodeAdded && (
            <StepDetails label="When" brandColor="#222222" name="Filter code" serviceName="Filter code" />
          )}
          {delayAdded && (
            <StepDetails label="Wait" brandColor="#222222" serviceName="Delay" name={`${formattedDelay()} delay`} />
          )}
          {actionsAdded &&
            details.applet_actions.map((action, i) => (
              <>
                <StepDetails
                  label={i > 0 ? "And" : "Then"}
                  brandColor={`#` + action.action.channel.brand_color}
                  image={action.action.channel.monochrome_image_url}
                  name={action.action.name}
                  serviceName={action.action.channel.name}
                  description={action.action.description}
                  finalStep={details.applet_actions.length === i + 1}
                />
              </>
            ))}
          <a className="txt-body-3" onClick={handleShowDetails}>
            Fewer details
          </a>
        </>
      ) : (
        <a className="txt-body-3" onClick={handleShowDetails}>
          More details
        </a>
      )}
    </div>
  )
}

export default AppletDetails
